import React from 'react';
import { STATUS_MAP } from './batchReportUtils';

interface ReportStatusBadgeProps {
    status?: string;
    onClick?: () => void;
    showDescription?: boolean;
}

const ReportStatusBadge: React.FC<ReportStatusBadgeProps> = ({ status, onClick, showDescription }) => {
    const cfg = STATUS_MAP[status?.toUpperCase() || ''];
    const label = cfg?.label || status || '';
    const bgClass = cfg?.bgClass || 'bg-gray-500';

    const badge = (
        <span
            className={`rounded px-2 py-1 text-xs font-bold text-white ${bgClass} ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
            title={cfg?.description}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
        >
            {label}
        </span>
    );

    if (showDescription && cfg?.description) {
        return (
            <span className="inline-flex items-center gap-2">
                {badge}
                <span className="text-xs text-gray-500">{cfg.description}</span>
            </span>
        );
    }

    return badge;
};

export default ReportStatusBadge;
